<template>
    <div class="w-100 px-2">
        <div class="d-flex justify-content-center">
            <div class="circle-wrap" :style="{ width: size + 'px', height: size + 'px' }">
                <canvas ref="cv" :width="size" :height="size"></canvas>
                <!-- text ở giữa -->
                <div class="center">
                    <div class="percent">{{ Math.round(current) }}%</div>
                    <div class="label">{{ label }}</div>
                </div>
            </div>
        </div>

        <div v-if="messages.length" class="alert border-warning px-1 mt-4" style="background-color: rgb(255 249 239);">
            <div class="d-flex align-items-start px-2">
                <div style="color: rgb(239 78 27);">
                    <p class="fw-medium bold" style="font-size: 15px;">
                        <i class="far fa-info-circle mr-1 mt-1" style="color: rgb(239 78 27) !important"></i>
                        Tiến độ cập nhật hồ sơ:</p>
                    <ul class="large mb-0 px-2" style="list-style-type: disc; list-style-position: outside; padding-left: 0; margin-left: 10px;">
                        <li style="font-size: 13px" v-for="(item, index) in messages" :key="index" class="mb-1">{{ item }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {GET_PROGRESS} from "../../../../core/services/store/profile.module";

export default {
    name: 'CircleProgressCanvas',
    props: {
        value: { type: Number, default: 100 },       // 0..100
        size: { type: Number, default: 180 },        // px
        stroke: { type: Number, default: 14 },       // độ dày vòng
        bgColor: { type: String, default: '#ECEFF4' }, // màu track
        gradientFrom: { type: String, default: '#6A5AF9' },
        gradientTo:   { type: String, default: '#00C2FF' },
        label: { type: String, default: 'Tiến độ' },
        startAtTop: { type: Boolean, default: true }, // bắt đầu từ 12h
        duration: { type: Number, default: 800 },      // ms, thời gian animate
        messages: { type: Array, default: [] },
    },
    data() {
        return {
            current: 0,        // giá trị đang hiển thị (animate tới value)
            _raf: null,
            _startTs: 0,
            _fromVal: 0,
            _toVal: 0,
        }
    },
    mounted() {
        this.current = this.value;
        this.draw()
    },
    watch: {
        value(newVal, oldVal) {
            this.animateTo(newVal, oldVal)
        },
        // khi đổi size/props màu -> vẽ lại
        size() { this.$nextTick(this.draw) },
        stroke() { this.$nextTick(this.draw) },
        gradientFrom() { this.$nextTick(this.draw) },
        gradientTo() { this.$nextTick(this.draw) },
        bgColor() { this.$nextTick(this.draw) }
    },
    beforeDestroy() {
        cancelAnimationFrame(this._raf)
    },
    methods: {
        // easeOutCubic
        ease(t){ return 1 - Math.pow(1 - t, 3) },

        animateTo(to, from = this.current) {
            cancelAnimationFrame(this._raf)
            this._startTs = 0
            this._fromVal = Math.max(0, Math.min(100, from))
            this._toVal   = Math.max(0, Math.min(100, to))

            const step = (ts) => {
                if (!this._startTs) this._startTs = ts
                const p = Math.min(1, (ts - this._startTs) / this.duration)
                const eased = this.ease(p)
                this.current = this._fromVal + (this._toVal - this._fromVal) * eased
                this.draw()
                if (p < 1) this._raf = requestAnimationFrame(step)
            }
            this._raf = requestAnimationFrame(step)
        },
        getProgress()
        {
            this.$store.dispatch(GET_PROGRESS).then((res) => {
                let data = res.data;
                let value = Math.ceil((data.count / data.total) * 100);

                this.messages = data.message;
            })
        },
        draw() {
            const canvas = this.$refs.cv
            if (!canvas) return
            const ctx = canvas.getContext('2d')
            const w = canvas.width, h = canvas.height
            const cx = w / 2, cy = h / 2
            const r = Math.min(w, h) / 2 - this.stroke / 2

            ctx.clearRect(0,0,w,h)

            // track
            ctx.beginPath()
            ctx.lineWidth = this.stroke
            ctx.strokeStyle = this.bgColor
            ctx.lineCap = 'round'
            ctx.arc(cx, cy, r, 0, Math.PI * 2)
            ctx.stroke()

            // gradient
            const grad = ctx.createLinearGradient(0, 0, w, h)
            grad.addColorStop(0, this.gradientFrom)
            grad.addColorStop(1, this.gradientTo)

            // progress arc
            const startAngle = this.startAtTop ? -Math.PI / 2 : 0
            const endAngle = startAngle + (Math.PI * 2) * (this.current / 100)

            ctx.beginPath()
            ctx.lineWidth = this.stroke
            ctx.strokeStyle = grad
            ctx.lineCap = 'round'
            ctx.arc(cx, cy, r, startAngle, endAngle, false)
            ctx.stroke()

            // chấm nhỏ ở đầu (tùy chọn, giống hình)
            const dotR = this.stroke * 0.35
            const dotX = cx + r * Math.cos(endAngle)
            const dotY = cy + r * Math.sin(endAngle)
            ctx.beginPath()
            ctx.fillStyle = grad
            ctx.arc(dotX, dotY, dotR, 0, Math.PI * 2)
            ctx.fill()
        }
    }
}
</script>

<style scoped>
.circle-wrap {
    position: relative;
    display: inline-block;
}
.center {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    user-select: none;
    text-align: center;
}
.percent {
    font-weight: 700;
    font-size: 28px;
    line-height: 1;
}
.label {
    margin-top: 4px;
    font-size: 13px;
    opacity: 0.7;
}
</style>
